/* eslint-disable no-async-promise-executor */
import { Injectable, Optional, inject } from '@angular/core';
import {
    Auth,
    authState,
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    createUserWithEmailAndPassword,
    sendEmailVerification,
} from '@angular/fire/auth';
import { IProviderAuth } from '../../../../../core/auth/interfaces/IProviderAuth';
import { Observable, firstValueFrom, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { FirebaseLibService } from '../../../firebase/firebase-lib.service';
import { User, UserAuth, UserType } from 'src/app/models/user';
import { LoginPayload } from '@core/auth/interfaces/login-payload';
import { LoginResponse } from '@core/auth/interfaces/login-response';
import { UsersService } from '@pages/users/users.service';
import { HttpClient } from '@angular/common/http';

const loginErrorCodes = {
    'auth/invalid-email': 'You must verify your email before logging in.',
    'auth/wrong-login': 'Invalid username or password',
};

@Injectable({
    providedIn: 'root',
})
export class FirebaseAuthProvider implements IProviderAuth {
    endpoint!: string;
    usersService = inject(UsersService);
    private http = inject(HttpClient);

    constructor(
        @Optional() private auth: Auth,
        private firebaseService: FirebaseLibService // eslint-disable-next-line no-empty-function
    ) {}
    async getCurrentUser(): Promise<User | null> {
        const obs = authState(this.auth).pipe(
        switchMap((user: any) => {
            if (!user) {
                console.warn('No authenticated user found');
                return of(null);
            }
            return this.firebaseService.getUserAccount(user.uid);
        })
        );
        return await firstValueFrom(obs);
    }

     sendRecoveryEmail(email: string, userType: UserType) {
        const userTypeP = userType;
        return this.http.get(
        `${this.endpoint}/recoverypwd?email=${email}&userType=${userTypeP}`
        );
    }
    async login(loginPayload: LoginPayload): Promise<LoginResponse> {
        const { email, password } = loginPayload;
        return new Promise<LoginResponse>(async (resolve, reject) => {
            try {
                const result = await signInWithEmailAndPassword(
                    this.auth,
                    email,
                    password
                );
                const userDb = await firstValueFrom(
                    this.usersService.getOne(result.user.uid, 'administration')
                );
                if (userDb) {
                    resolve({
                        success: true,
                        errorCode: null,
                    });
                } else {
                    reject(loginErrorCodes['auth/wrong-login']);
                }
            } catch (error) {
                reject(loginErrorCodes['auth/wrong-login']);
            }
        });
    }

    /*  register(user: UserAuth): Promise<AppUser> {
    return new Promise<AppUser>(async (resolve, reject) => {
      try {
        const { email, password } = user;
        const result = await createUserWithEmailAndPassword(
          this.auth,
          email,
          password
        );

        // send verification email
        await sendEmailVerification(result.user);

        this.firebaseService.setModel('users');

        const userToSave: Partial<AppUser> = {
          createdAt: new Date(),
          photoURL: '',
          role: Role.USER,
          nombre: user.nombre,
          apellido: user.apellido,
          email: user.email,
        };
        this.firebaseService
          .create<Partial<AppUser>>(result.user.uid, userToSave)
          .then(() => {
            resolve(user);
          });
      } catch (error: any) {
        const errorMessage =
          error?.code === 'auth/email-already-in-use'
            ? 'El email ya está en uso'
            : 'Error al crear el usuario';
        reject(errorMessage);
      }
    });
  } */

     async register(user: UserAuth): Promise<any> {
        return new Promise<any>(async (resolve, reject) => {
            try{
                 const { email, password } = user;

                //buscar usuario por mail

                const result = await createUserWithEmailAndPassword(
                    this.auth,
                    email,
                    password
                );


                delete user.password;
                const dataUser={...user};

                this.firebaseService.setModel('users');


                 // send verification email
                //await sendEmailVerification(result.user);

              /*  dataUser['createdAt'] = new Date();
                    this.firebaseService
                        .create(result.user.uid, dataUser)
                        .then(() => {
                            resolve(user);
                        }); */
                resolve(user);
            }catch(error){
                reject({
                    success: false,
                    errorCode: error
                });
            }
        });
    }

    unregister(user: unknown): Promise<boolean>{
        return new Promise<boolean>(async (resolve, reject) => {
            try {
                const currentUser = this.auth.currentUser;
                if (currentUser) {
                    await currentUser.delete();
                    resolve(true);
                } else {
                    reject(false);
                }
            } catch (error) {
                reject(false);
            }
        });
    }

    async logout(): Promise<void> {
        await signOut(this.auth);
    }
    
    getLoggedUser(): Observable<User | null> {
        return authState(this.auth).pipe(
            // tap(user => console.log('AuthState user:', user)), // Log authentication state
            switchMap((user: any) => {
                // console.log('Auth:', this.auth);
                if (!user) {
                    console.warn('No authenticated user found');
                    return of(null);
                }
                return this.firebaseService.getUserAccount(user.uid)
                    // .pipe(tap(accountData => console.log('Firestore account:', accountData))
                // );
            })
        );
    }
    

   

    isLoggedIn(): Observable<boolean> {
        return authState(this.auth).pipe(map((user) => !!user));
    }

    recoveryPassword(email: string): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            try {
                await sendPasswordResetEmail(this.auth, email);
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
}
